/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
import React from 'react';
import defaultUser from '../../../../assets/defaultImages/defaultUser.png';
import DriverModal from './modal/DriverModal';
import { permissionType } from '../../../../enums/permissionTypeEnum';
import HeadTittle from '../../../../components/HeadTittle';
import {EditIcon} from '../../../../components/buttons/IconButtons';
import DivContainerBody from '../../../../components/DivContainerBody';
import DividerWithText from '../../../../components/DividerWithText';
import {ButtonLargeTransparent} from '../../../../components/buttons/ButtonLargeTransparent';
import routes from '../../../../Routes/routes';
import CustomGalleryFiles from '../../../../components/CustomGalleryFiles';
import {EMPTY_VALUES, getDateFormat} from '../../../../Apis/functions';
import RowResumeText from '../../../../components/RowResumeText';
import {statusBorderColor, statusColor, statusFontColor} from '../../../../enums/statusColorEnum';
import CustomChip from '../../../../components/CustomChip';
import CustomCard from '../../../../components/CustomCard';
import ButtonIcon from '../../../../components/buttons/ButtonIcon';
import ImagePreview from '../../../../components/ImagePreview';
import ButtonSubAction from '../../../../components/buttons/ButtonSubAction';
import EmployeeVehicleDetailApp from './Functionality/EmployeeVehicleDetailApp';
import NotInformation from '../../../../components/NotInformation';
import {status} from "../../../../enums/statusEnum";

const EmployeeVehicleDetail = () => {

    const {
        id, t,
        showModal, setShowModal,
        isDriverAdd, setIsDriverAdd,
        setUpdateDriverId,
        driverNameUpdate, setDriverNameUpdate,
        pagination,
        getAllDriverRelationship,
        getListOfVehicleImages,
        getVehicleById,
        updateDriver,
    } = EmployeeVehicleDetailApp();

    return (
        <>
            <HeadTittle name={'details'} link={routes.vehicleFleet.list} />
            <DivContainerBody>
                <div className='row'>
                    <div className='col-12'>
                        <DividerWithText title={t('data')} />
                    </div>
                    <div className='col-12 d-flex justify-content-end'>
                        <CustomChip
                            background={statusColor[getVehicleById?.status?.id]}
                            fontColor={statusFontColor[getVehicleById?.status?.id]}
                            borderColor={statusBorderColor[getVehicleById?.status?.id]}
                            legend={t(status[getVehicleById?.status?.id]) || EMPTY_VALUES.DEFAULT}
                        />
                    </div>
                    <div className='col-6'>
                        <RowResumeText title={t('brand')} value={getVehicleById?.brand || EMPTY_VALUES.DEFAULT} />
                        <RowResumeText title={t('sub_brand')} value={getVehicleById?.subBrand || EMPTY_VALUES.DEFAULT} />
                        <RowResumeText title={t('color')} value={getVehicleById?.color || EMPTY_VALUES.DEFAULT} />
                        <RowResumeText title={t('model')} value={getVehicleById?.model || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className='col-6'>
                        <RowResumeText title={t('plates')} value={getVehicleById?.plate || EMPTY_VALUES.DEFAULT} />
                        <RowResumeText title={t('vin')} value={getVehicleById?.vin || EMPTY_VALUES.DEFAULT}/>
                        <RowResumeText title={t('serial_number')} value={getVehicleById?.serialNumber || EMPTY_VALUES.DEFAULT} />
                        <RowResumeText title={t('tag')} value={getVehicleById?.tag || EMPTY_VALUES.DEFAULT} />
                    </div>
                    <div className='col-12 my-4'>
                        <DividerWithText title={t('drivers')} />
                    </div>

                    <div className='col-12'>
                        {getAllDriverRelationship?.length > 0 ? <>
                                {getAllDriverRelationship?.map((item) => {
                                    const fromDate = item?.from ? new Date(item?.from) : null;
                                    const toDate = item?.to ? new Date(item?.to) : null;
                                    return (
                                        <div className='col-4 mt-4'>
                                            <CustomCard classContent={'px-0 py-0'}>
                                                <div className='col-12 d-flex justify-content-end'>
                                                    <ButtonIcon
                                                        id='btn_evd_update'
                                                        className='btn-background-transparent'
                                                        iconProps='btn-icon-svg-green btn-icon-svg-12px'
                                                        Icon={EditIcon}
                                                        onClick={() => {
                                                            setShowModal(true);
                                                            setIsDriverAdd('update');
                                                            setUpdateDriverId(item?.id);
                                                            setDriverNameUpdate(item);
                                                        }}
                                                    />
                                                </div>
                                                <div className='row'>
                                                    <div className='col-3'>
                                                        <ImagePreview className='' classNameWH='w-100px-h-100px' preview={item?.selfie ? `data:image/png;base64,${item?.selfie}` : defaultUser} />
                                                        <div className='d-flex align-items-center justify-content-center mt-2'>
                                                            <ButtonSubAction
                                                                id='btn_evd_see_details'
                                                                name='see_details'
                                                                url={`${routes.employee.edit}${item?.userId}`}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='col-9'>
                                                        <div className='row'>
                                                            <div className='col-6'>
                                                                <RowResumeText title={t('name')} value={item?.name || EMPTY_VALUES.DEFAULT}  />
                                                            </div>
                                                            <div className='col-6'>
                                                                <RowResumeText title={t('employee_id')} value={item?.employeeId || EMPTY_VALUES.DEFAULT} />
                                                            </div>
                                                            <div className='col-6'>
                                                                <RowResumeText title={t('phone_number')} value={item?.phoneNumber || EMPTY_VALUES.DEFAULT}  />
                                                            </div>
                                                            <div className='col-6'>
                                                                <RowResumeText title={t('permission_type')} value={t(permissionType[item?.vehiclePermissionTypeId]) || EMPTY_VALUES.DEFAULT}  />
                                                            </div>
                                                            <div className='col-6'>
                                                                <RowResumeText title={t('from')} value={fromDate ? getDateFormat(fromDate, false) : EMPTY_VALUES.DEFAULT}  />
                                                            </div>
                                                            <div className='col-6'>
                                                                <RowResumeText title={t('to')} value={toDate ? getDateFormat(toDate, false) : EMPTY_VALUES.DEFAULT}  />
                                                            </div>
                                                            <div className='col-12'>
                                                                <RowResumeText title={t('email')} value={item?.email || EMPTY_VALUES.DEFAULT}  />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CustomCard>
                                        </div>

                                    )
                                })}
                            </> :
                            <>
                                <NotInformation text={t('no_information')} card={true} />
                            </>
                        }

                    </div>
                    <div className='col-12 my-4'>
                        <ButtonLargeTransparent
                            id="btn_evd_add_driver_item"
                            click={() => {
                                setShowModal(true);
                                setIsDriverAdd('add');
                            }}
                            text={t("add_driver")}
                        />
                    </div>

                    <div className='col-12'>
                        <DividerWithText title={t('images')} />
                    </div>
                    <div className='col-12'>
                        <>
                            <CustomGalleryFiles
                                className='mt-3'
                                listData={getListOfVehicleImages}
                            />
                            {pagination()}
                        </>
                    </div>
                </div>
            </DivContainerBody>

            {showModal &&
                <DriverModal
                    title={isDriverAdd === 'add' ? t('create_driver') : t('update_driver')}
                    checkmodal={isDriverAdd}
                    id={id}
                    updateDriver={updateDriver}
                    show={showModal}
                    data={driverNameUpdate}
                    setData={setDriverNameUpdate}
                    onHide={() => {
                        setDriverNameUpdate('');
                        setShowModal(false);
                    }}
                />
            }

        </>
    );
};

export default EmployeeVehicleDetail;
